<template>
  <div class="c-comments-wrap">
    <div class="c-rates-wrap">
      <div class="left">
        <gxxt-rate show-score direction="vertical" v-model="comments.starScore" disabled></gxxt-rate>
      </div>
      <div class="right">
        <div class="c-rate-percent">
          <gxxt-rate :max="5" :size="16"></gxxt-rate>
          <gxxt-progress :size="180" v-model="comments.fiveStarRatio"></gxxt-progress>
        </div>
        <div class="c-rate-percent">
          <gxxt-rate :max="4" :size="16"></gxxt-rate>
          <gxxt-progress :size="180" v-model="comments.fourStarRatio"></gxxt-progress>
        </div>
        <div class="c-rate-percent">
          <gxxt-rate :max="3" :size="16"></gxxt-rate>
          <gxxt-progress :size="180" v-model="comments.threeStarRatio"></gxxt-progress>
        </div>
        <div class="c-rate-percent">
          <gxxt-rate :max="2" :size="16"></gxxt-rate>
          <gxxt-progress :size="180" v-model="comments.twoStarRatio"></gxxt-progress>
        </div>
        <div class="c-rate-percent">
          <gxxt-rate :max="1" :size="16"></gxxt-rate>
          <gxxt-progress :size="180" v-model="comments.oneStarRatio"></gxxt-progress>
        </div>
      </div>
    </div>
    <div class="c-comment-list-wrap">
      <comment-item
        v-for="(c, index) in comments.commentList"
        :key="c.id"
        :item="c"
        :index="index"
        @changeItemLike="changeItemLike"
      ></comment-item>
      <gxxt-no-data class="mt100" text="暂无评论~" v-if="comments.commentList.length == 0"></gxxt-no-data>
    </div>
  </div>
</template>

<script>
import { GxxtRate, GxxtProgress, GxxtNoData } from '@/components'
import CommentItem from './comment-item'
export default {
  props: {
    goodsType: {
      type: [Number, String],
      default: '',
    },
    goodsId: {
      type: [Number, String],
      default: '',
    },
  },
  components: {
    GxxtRate,
    GxxtProgress,
    CommentItem,
    GxxtNoData,
  },
  data() {
    return {
      loadComments: false,
      comments: {
        commentList: [],
        fiveStarRatio: 0,
        fourStarRatio: 0,
        threeStarRatio: 0,
        twoStarRatio: 0,
        oneStarRatio: 0,
      },
    }
  },
  watch: {
    goodsId: {
      handler(v) {
        this.getComments()
      },
      immediate: true,
    },
  },
  methods: {
    changeItemLike(index) {
      this.comments.commentList[index].like =
        !this.comments.commentList[index].like
      if (this.comments.commentList[index].like) {
        this.comments.commentList[index].likeNum += 1
      } else {
        this.comments.commentList[index].likeNum -= 1
      }
    },
    async getComments() {
      this.loadComments = true
      let res = await this.api.course.getGoodsCommentList(this.goodsId)
      if (res && res.code == 200) {
        if (res.data && res.data.commentList) {
          this.comments = res.data
        }
      }
      this.loadComments = false
    },
  },
}
</script>

<style scoped lang="less">
.c-rates-wrap {
  display: flex;
  padding: 30px 50px 0 70px;
  .left {
    padding-right: 62px;
    border-right: 1px solid #f3f3f3;
  }
  .right {
    padding-left: 56px;
  }
  .c-rate-percent {
    display: flex;
    justify-content: flex-end;
  }
}
</style>